<template>
  <MainPage>
    <form class='page-login-form' @submit.prevent='doLogin'>
      <div class='logo-arvalis'/>
      <div class='wrap'>
        <label for='email'>Identifiant</label>
        <input v-focus v-model='email' type='text' name='email' id='email' required placeholder='Identifiant de connexion (email)' >
      </div>
      <div class='wrap'>
        <label for='password'>Mot de passe</label>
        <input v-model='password' type='password' name='password' id='password' required placeholder='Mot de passe' >
        <a class="btn-frgt-passwd" @click="$router.push('/recoverPassword')"><span>Mot de passe oublié ?</span></a>
      </div>
      <div class="ct-flex-row ct-jc-space">
        <input type='submit' class="primary-action" name='login' value='Se connecter'>
        <input type='button' class="secondary-action" @click="$router.push('/inscription')" value="M'inscrire" />
      </div>
    </form>
  </MainPage>
</template>

<script>
import MainPage from './MainPage'
import { mapActions } from 'vuex'
import { REDIRECT } from '@/store/mutation-types'

export default {
  name: 'login',

  components: {
    MainPage
  },

  data () {
    return {
      email: null,
      password: null
    }
  },
  methods: {
    ...mapActions(['login']),

    doLogin () {
      this.login({
        email: this.email,
        password: this.password
      })
        .then(() => {
          let idExploitation = this.$store.state.auth.idExploitation
          let defaultUrl = idExploitation ? { name: 'exploitation_information', params: { idExploitation } } : { name: 'exploitations' }
          let url = this.$store.state.auth.redirect || defaultUrl
          this.$store.commit(REDIRECT, null)
          this.$router.push(url)
        })
        .catch(() => {
          alert('Identifiant/mot de passe incorrect')
        })
    }
  }
}
</script>
